"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class HTMLHeadComponent extends HTMLElement {
    constructor() {
        super();
        this.data = [];
        this.elements = [];
    }
    static get observedAttributes() {
        return ['data', 'src'];
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const src = this.getAttribute('src');
            const data = this.getAttribute('data');
            this.removeElements();
            this.data = src ? yield this.fetchData(src) : this.parseAttribute(data);
            this.createElements();
        });
    }
    attributeChangedCallback(name, _, newValue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (name !== 'data') {
                return;
            }
            this.removeElements();
            this.data = this.parseAttribute(newValue);
            this.createElements();
        });
    }
    removeElements() {
        for (const el of this.elements) {
            document.head.removeChild(el);
        }
        this.elements = [];
    }
    createElements() {
        for (const item of this.data) {
            const { tag } = item, attrs = __rest(item, ["tag"]);
            if (tag === 'title') {
                document.title = attrs.content || '';
                continue;
            }
            document.head.appendChild(this.createElement(tag, attrs));
        }
    }
    createElement(tag, attrs) {
        const el = document.createElement(tag);
        Object.keys(attrs).forEach((attr) => {
            const attribute = attr.substring(0, 3) === 'og:' ? 'property' : attr;
            if (this.hasContent(attr, tag)) {
                el.innerHTML = attrs[attr];
            }
            else {
                el.setAttribute(attribute, attrs[attr] || '&nbsp;');
            }
        });
        this.elements.push(el);
        return el;
    }
    hasContent(attr, tag) {
        return attr === 'content' && ['style', 'script', 'noscript'].includes(tag);
    }
    parseAttribute(value) {
        if (!value) {
            return [];
        }
        try {
            return JSON.parse(value);
        }
        catch (e) {
            return [];
        }
    }
    fetchData(src) {
        return __awaiter(this, void 0, void 0, function* () {
            return fetch(src).then((r) => r.json());
        });
    }
}
window.customElements.define('html-head-component', HTMLHeadComponent);
//# sourceMappingURL=index.js.map